module.exports = __webpack_public_path__ + "media/fonts/Objectivity-Medium-6be76389d3b94ee20e79de3971f07f67.woff2";